/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FetchData } from 'app/shared/generalMethods';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AdminProfileService {
    headers: HttpHeaders;
        options: any;
        user: any;
        serverUrl = environment.apiUrl;
        serverCache = environment.apiUrlCache;

        constructor(
            private http: HttpClient,
            private _httpClient: HttpClient,
            private _fetchData: FetchData
        ){}


    updateAdminProfile(record: any, adminId: string): Observable<any> {

        const url = this.serverUrl + '/updateAdminProfile';
        const body = {
            parenIdOrUid: adminId,
            uid: adminId,
            name: record.Administrator_Name__c,
            email: record.Email__c,
            address: record.Address__c,
            city: record.Town_City__c,
            isActive: record.Is_Active__c,
            role: record.Role__c,
            cellPhone: record.Phone__c
        };
        return this._httpClient.put(url, body, this.options);
    }

    createProgram(programData: any, adminId: string): Observable<any> {
            const url = this.serverUrl + '/createProgram?adminId=' + adminId;
            const body = {
                adminIdOrUid: adminId,
                Name: programData.Name,
                Program_Description__c: programData.Program_Description__c,
                Program_Catergory__c: programData.Program_Catergory__c,
                Age_Group__c: programData.Age_Group__c,
                Is_Active__c: programData.Is_Active__c,
                All_Day_Program__c: programData.All_Day_Program__c,
                Program_Location__c: programData.Program_Location__c,
                Location__c: programData.Location__c,
                Instructor__c: programData.Instructor__c,
                Start_Date__c: programData.Start_Date__c,
                End_Date__c: programData.End_Date__c,
                Monday__c: programData.Monday__c,
                Tuesday__c: programData.Tuesday__c,
                Wednesday__c: programData.Wednesday__c,
                Thursday__c: programData.Thursday__c,
                Friday__c: programData.Friday__c,
                Saturday__c: programData.Saturday__c,
                Sunday__c: programData.Sunday__c,
                Start_Time_Monday__c: programData.Start_Time_Monday__c,
                End_Time_Monday__c: programData.End_Time_Monday__c,
                Start_Time_Tuesday__c: programData.Start_Time_Tuesday__c,
                End_Time_Tuesday__c: programData.End_Time_Tuesday__c,
                Start_Time_Wednesday__c: programData.Start_Time_Wednesday__c,
                End_Time_Wednesday__c: programData.End_Time_Wednesday__c,
                Start_Time_Thursday__c: programData.Start_Time_Thursday__c,
                End_Time_Thursday__c: programData.End_Time_Thursday__c,
                Start_Time_Friday__c: programData.Start_Time_Friday__c,
                End_Time_Friday__c: programData.End_Time_Friday__c,
                Start_Time_Saturday__c: programData.Start_Time_Saturday__c,
                End_Time_Saturday__c: programData.End_Time_Saturday__c,
                Start_Time_Sunday__c: programData.Start_Time_Sunday__c,
                End_Time_Sunday__c: programData.End_Time_Sunday__c,
                Available_Space__c: programData.Available_Space__c,
                Available_Waiting_Space__c: programData.Available_Waiting_Space__c,
                Program_Fee__c: programData.Program_Fee__c,
                Subsidized_Amount__c: programData.Subsidized_Amount__c,
                Cancellation_Policy__c: programData.Cancellation_Policy__c,
                Payment_Term__c: programData.Payment_Term__c,
                Payment_Disclaimer__c: programData.Payment_Disclaimer__c,
                Gain_Description__c: programData.Gain_Description__c,
                Notes__c: programData.Notes__c,
                Less_than_days__c: programData.Less_than_days__c,
                In_between_days__c: programData.In_between_days__c,
                Greater_than_days__c: programData.Greater_than_days__c,
                Percentage_Less__c: programData.Percentage_Less__c,
                Percentage_Between__c: programData.Percentage_Between__c,
                Percentage_Greater__c: programData.Percentage_Greater__c,
                Message_Less_than_days__c: programData.Message_Less_than_days__c,
                Message_In_between_days__c: programData.Message_In_between_days__c,
                Message_Greater_than_days__c: programData.Message_Greater_than_days__c,
                isActive: true,
                ignoreValidation: false
            };
            return this._httpClient.post(url, body, this.options);
        }
}
